<script lang="ts">
    import src from './svg/pending_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';
    export let spin: boolean = false;
</script>

<TemplateIcon {src} {spin} {scale} alt={title} hover={title} on:click />
